import { useContext, useState } from "react";
import { initPayWithCustomer, initPayWithPaymentMethod, updatePayInitiation, updatePayInitiationWithCustomer, } from "./PaymentUtils";
import { BillingInformationContext } from "../../../BillingInformationContext";
import { PaymentProcessor } from "../../types/PaymentProcessorTypes";
export const usePayment = () => {
    const [loading, setLoading] = useState(false);
    const { clientSecret, paymentIntentId, publicKey, token, paymentProcessor, setPublicKey, setPaymentIntentId, setClientSecret, setDoesPaymentIntentExist, setPaymentProcessor, doesPaymentIntentExist, } = useContext(BillingInformationContext);
    return {
        loading,
        initPayWithCustomer: initPayWithCustomer(setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setPaymentProcessor),
        updatePayInitiationWithCustomer: updatePayInitiationWithCustomer(setLoading, setPublicKey, setPaymentIntentId, setClientSecret),
        initPayWithPaymentMethod: initPayWithPaymentMethod(setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setDoesPaymentIntentExist, setPaymentProcessor),
        updatePayInitiation: updatePayInitiation(setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setDoesPaymentIntentExist, {
            Stripe: {
                ClientSecret: clientSecret !== null && clientSecret !== void 0 ? clientSecret : "",
                PaymentIntentId: paymentIntentId !== null && paymentIntentId !== void 0 ? paymentIntentId : "",
            },
            Tap: {
                PublicKey: publicKey !== null && publicKey !== void 0 ? publicKey : "",
            },
            AuthorizeNet: {
                HostedFormToken: token !== null && token !== void 0 ? token : "",
            },
            PaymentProcessor: paymentProcessor !== null && paymentProcessor !== void 0 ? paymentProcessor : PaymentProcessor.UNKNOWN,
        }),
        doesPaymentIntentExist,
    };
};
